import React from 'react';

/**
 * Renders copy with optional **bold** segments (from mock guide strings).
 */
export function GuideText({ children, className }) {
  const text = typeof children === 'string' ? children : '';
  if (!text) return null;

  const nodes = [];
  let key = 0;
  const regex = /\*\*([^*]+)\*\*/g;
  let lastIndex = 0;
  let m = regex.exec(text);

  if (!m) {
    return className ? <span className={className}>{text}</span> : text;
  }

  while (m !== null) {
    if (m.index > lastIndex) {
      nodes.push(<React.Fragment key={`t-${key++}`}>{text.slice(lastIndex, m.index)}</React.Fragment>);
    }
    nodes.push(
      <strong key={`b-${key++}`} className="font-semibold text-[#0f2540]">
        {m[1]}
      </strong>,
    );
    lastIndex = m.index + m[0].length;
    m = regex.exec(text);
  }
  if (lastIndex < text.length) {
    nodes.push(<React.Fragment key={`t-${key++}`}>{text.slice(lastIndex)}</React.Fragment>);
  }

  return <span className={className}>{nodes}</span>;
}
